<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <template v-slot:activator="{ on }">
      <a href="#" @click.stop="dialog = true">
        {{ name }}
      </a>
    </template>
    <v-toolbar dark color="primary" class="toolbar">
        <v-btn icon dark @click="dialog = false">
          <v-icon v-once>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ name }}</v-toolbar-title>
      </v-toolbar>
    <v-card style="max-height:100%; height:100%;">
      
      <div style="position: relative; max-height:7.5%; height:7.5%;"></div>
      <div class="pa-12" style=" max-height:92.5%; height:92.5%; overflow-y:scroll;">
        <slot>
          <a href="https://wordtohtml.net/">https://wordtohtml.net/</a>
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ipsum,
          ratione laboriosam accusantium quaerat earum asperiores ut, nemo
          facere molestiae est maxime. Eius voluptate iste cumque a nihil
          laboriosam nobis deserunt?
        </slot>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "PolicyDialogLink",
  props: {
    name: String,
  },
  data() {
    return {
      dialog: false,
    };
  },
};
</script>
<style scoped>
  .toolbar {
    position: fixed;
    width: 100%;
    max-height:100px; 
    height:100px;
    z-index: 99;
  }
</style>
